import PropTypes from "prop-types";
import React, { useContext } from "react";
import { IconButton } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import DeleteIcon from "@material-ui/icons/Delete";

import { FleetSettingsContext } from "../../../../context";
import { feeTypes, taxNames, taxTypes } from "../../../../constants";

const generateUniqId = () => String(Date.now());

const ActionIcon = ({ action, field, fieldId }) => {
  const { billing, setBillingSettingsForm, fineTypes } = useContext(FleetSettingsContext);

  const addField = () => {
    const blankFields = {
      fees: { id: generateUniqId(), name: "", type: feeTypes[0], amount: "" },
      rate_plan_fine_types: { id: generateUniqId(), fine_type_id: fineTypes[0]?.id, amount: "" },
      tax: { name: taxNames[0], rate: "", type: taxTypes[0] },
    };

    setBillingSettingsForm({
      ...billing,
      [field]: field === "tax" ? blankFields.tax : [...billing[field], blankFields[field]],
    });
  };

  const removeField = () => {
    setBillingSettingsForm({
      ...billing,
      [field]: field === "tax" ? {} : billing[field].filter((obj) => obj.id !== fieldId),
    });
  };

  return (
    <>
      {action === "add" && (
        <IconButton
          size="small"
          style={{ margin: "8px", padding: "0 8px" }}
          data-testid={`${action}-${field}`}
          onClick={addField}
        >
          <AddCircleIcon />
        </IconButton>
      )}
      {action === "remove" && (
        <IconButton
          size="small"
          color="secondary"
          style={{ margin: "32px 8px", padding: "0 8px" }}
          data-testid={`${action}-${field}-${fieldId}`}
          onClick={removeField}
        >
          <DeleteIcon />
        </IconButton>
      )}
    </>
  );
};

ActionIcon.propTypes = {
  action: PropTypes.string.isRequired,
  field: PropTypes.string.isRequired,
  fieldId: PropTypes.string,
};

ActionIcon.defaultProps = {
  fieldId: null,
};

export default ActionIcon;
